import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { t, buildPath } = useI18n();
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-4 py-24 bg-slate-50">
      <div className="text-center max-w-lg">
        <p className="text-xs font-semibold uppercase tracking-widest text-teal-700">404</p>
        <h1 className="mt-3 font-jakarta text-4xl sm:text-5xl font-extrabold text-slate-900">
          {t("not_found.title")}
        </h1>
        <p className="mt-4 text-base text-slate-600">{t("not_found.description")}</p>
        <Link to={buildPath("")} className="inline-block mt-8" data-testid="notfound-back-home">
          <Button className="h-11 rounded-md px-6 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold">
            {t("not_found.back")}
          </Button>
        </Link>
      </div>
    </main>
  );
}
